// ─────────────────────────────────────────────
//  theme.js — Tema claro / oscuro de la PWA
// ─────────────────────────────────────────────

import { DEFAULTS } from './defaults';
import { KEYS, getSetting } from './storage';

const THEME_COLORS = {
	dark:  { theme: '#111111', background: '#111111' },
	light: { theme: '#f2f2f7', background: '#f2f2f7' },
};

export function applyTheme(theme = getSetting(KEYS.theme, DEFAULTS.theme)) {
	const resolved = theme === 'light' ? 'light' : 'dark';
	document.documentElement.setAttribute('data-theme', resolved);

	const colors = THEME_COLORS[resolved];
	const meta = document.querySelector('meta[name="theme-color"]');
	if (meta) meta.setAttribute('content', colors.theme);
}
